import { useParams } from 'react-router';
import { validateObjectId } from 'utils/objectId.validation';

/**
 * Use object id from route path params
 */
export function useObjectIdRouteParam(key = 'resourceId'): string | undefined {
  const resourceId = useParams()[key];

  if (resourceId === 'new') return 'new';

  if (resourceId == null || resourceId == '') {
    return undefined;
  }

  if (!validateObjectId(resourceId)) {
    return undefined;
  }

  return resourceId;
}
